import React, { Component } from 'react'
import styles from "./index.module.css";
export default class spacer extends Component {
    render() {
        return (
            <div className={styles.spacer__container}>
                
            </div>
        )
    }
}
